import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Pagination from '../HelperComponents/Pagination/Pagination';
import PanelPage from '../HelperComponents/PanelPage/PanelPage';
import TransitionedBlock from "../HelperComponents/TransitionedBlock/TransitionedBlock";
import SnackBar from "../HelperComponents/SnackBar/SnackBar";
import RefundRequestsHeaderButtonsPanel from "../RefundRequests/RefundRequestsHeaderButtonsPanel/RefundRequestsHeaderButtonsPanel"
import Checkbox from "@material-ui/core/Checkbox";
import { getStatusRefundRequest, getStatusColor, formatPrice } from "../../helpers/functions";
import { getRefundRequests, postCreateJoinRequest } from "../../actions/refundRequestsActions";
import { getProviders } from "../../actions/providersActions";
import '../RefundRequests/RefundRequests.scss';
import ControlPanel from '../HelperComponents/ControlPanel/ControlPanel';

class RefundRequestsBuyer extends Component {

    state = {
        loading: true,
        activePage: 1,
        pageSize: 10,
        valueSearch: '',
        status: null,
        projects_list: [
            { label: "На рассмотрении", value: "processing" },
            { label: "Одобрена", value: "complete" },
            { label: "Отказ", value: "denied" },
            { label: "Ожидаем документы", value: "waiting_for_documents" },
            { label: "Ожидаем деталь", value: "waiting_for_details" },
            { label: "Деталь получена", value: "details_received" },
        ],
        provider: null,
        provider_list: [],
        fromDate: null,
        toDate: null,
        ordering: null,
        ordering_options: [
            { label: "Сначала новые", value: "-date" },
            { label: "Сначала старые", value: "date" },
        ],
        selectedRows: {},
        unionForIds: [],
        openRows: {},
        snackBarAttr: {
            isVisible: false,
            message: '',
        },
        actionLoading: false,
    };

    parseQueryToState = () => {
        const params = new URLSearchParams(this.props.location.search);
        const { projects_list, ordering_options } = this.state;
        const next = {};

        const page = params.get('page');
        if (page) next.activePage = Number(page) || 1;
        const pageSize = params.get('page_size');
        if (pageSize) next.pageSize = Number(pageSize) || 10;
        const q = params.get('query');
        if (q) next.valueSearch = q;
        const statusVal = params.get('status');
        if (statusVal) {
            const found = projects_list.find((s) => s.value === statusVal);
            next.status = found || { label: statusVal, value: statusVal };
        }
        const providerVal = params.get('provider');
        if (providerVal) next.provider = { label: providerVal, value: providerVal };
        const fromDate = params.get('from_date');
        if (fromDate) next.fromDate = new Date(fromDate);
        const toDate = params.get('to_date');
        if (toDate) next.toDate = new Date(toDate);
        const orderingVal = params.get('ordering');
        if (orderingVal) {
            const found = ordering_options.find((o) => o.value === orderingVal);
            next.ordering = found || { label: orderingVal, value: orderingVal };
        }

        return next;
    };

    syncStateToQuery = () => {
        const { activePage, pageSize, valueSearch, status, provider, fromDate, toDate, ordering } = this.state;
        const params = new URLSearchParams();

        if (activePage && activePage !== 1) params.set('page', String(activePage));
        if (pageSize && pageSize !== 10) params.set('page_size', String(pageSize));
        if (valueSearch) params.set('query', valueSearch);
        if (status && status.value) params.set('status', status.value);
        if (provider && provider.value) params.set('provider', provider.value);
        if (fromDate) params.set('from_date', moment(fromDate).format('YYYY-MM-DD'));
        if (toDate) params.set('to_date', moment(toDate).format('YYYY-MM-DD'));
        if (ordering && ordering.value) params.set('ordering', ordering.value);

        const search = params.toString();
        const newSearch = search ? `?${search}` : '';
        if (this.props.location.search !== newSearch) {
            this.props.history.replace({
                ...this.props.location,
                search: newSearch,
            });
        }
    };

    toggleRow = (id) => {
        this.setState((prevState) => ({
            openRows: {
                ...prevState.openRows,
                [id]: !prevState.openRows[id]
            }
        }));
    }

    componentDidMount = () => {
        const fromQuery = this.parseQueryToState();
        this.setState(fromQuery, () => {
            this.doRequest();
            this.getProviderList();
        });
        const { location } = this.props;
        if (location.state && location.state.isVsibleSnackBar) {
            this.setState({
                snackBarAttr: {
                  isVisible: true,
                  message: location.state.snackBarMessage,
                }
            });
            this.props.history.replace({
                ...this.props.location,
                state: {},
            });
        }
    };

    get selectedRowsLength() {
        return Object.values(this.state.selectedRows).filter((row) => row.checked).length
    }

    doRequest = () => {
        const { getRefundRequests } = this.props;
        const { activePage, pageSize, valueSearch, status, provider, unionForIds, fromDate, toDate, ordering } = this.state;

        let arr = [];
        arr.push(`company_role=wholesale_customer`);
        if (!!status && status !== null) {
            arr.push(`status=${status.value}`);
            this.setState({ status })
        } else {
            this.setState({ status: '' })
        }
        if (valueSearch !== "") {
            arr.push(`query=${valueSearch}`);
        }
        if (provider !== null) {
            arr.push(`provider=${provider.value}`);
        }
        if (fromDate) {
            arr.push(`from_date=${moment(fromDate).format('YYYY-MM-DD')}`);
        }
        if (toDate) {
            arr.push(`to_date=${moment(toDate).format('YYYY-MM-DD')}`);
        }
        if (ordering && ordering.value) {
            arr.push(`ordering=${ordering.value}`);
        }
        if (unionForIds.length > 0) {
            arr.push(`union_for=${unionForIds.join(',')}`);
        }
        arr.push(`page_size=${pageSize}`);
        arr.push(`page=${activePage}`);

        this.syncStateToQuery();

        getRefundRequests(arr).then(res => {
            if (res.payload && res.payload.status) {
                const prevSelectedRows = this.state.selectedRows;
                const refundRequestMap = res.payload.data.results.reduce((acc, item) => {
                    acc[item.id] = {
                        checked: prevSelectedRows[item.id] ? prevSelectedRows[item.id].checked : false,
                        amount: item.amount,
                        id: item.id,
                        orderNum: item.ordernum,
                        productInfo: item.product_info,
                        documentNumber: item.document_number || item.upd_number,
                    }
                    return acc;
                }, {})
                this.setState({ loading: false, selectedRows: refundRequestMap, requestError: false });
            } else {
                this.setState({ loading: false, activePage: 1, requestError: true });
            }
        });
    };

    toggleSnack = () => {
        this.setState({
            snackBarAttr: {
              isVisible: false,
              message: '',
            }
        });
      };

    changeValueSearch = e => {
        this.setState({ valueSearch: e.target.value });
    };

    handleSearch = e => {
        const { status } = this.state;

        if (e.keyCode === 13) {
            this.setState({ activePage: 1 });
            setTimeout(() => {
                this.doRequest(status);
            }, 0);
        } else if (e === "iconClick") {
            setTimeout(() => {
                this.doRequest(status);
            }, 0);
        }
    };

    handleChange = (name, event) => {
        this.setState({ [name]: event, activePage: 1 });
        setTimeout(() => {
            this.doRequest();
        }, 0);
    };

    handleDateRangeApply = ({ fromDate, toDate }) => {
        this.setState({ fromDate, toDate, activePage: 1 }, () => {
            this.doRequest();
        });
    };

    handleDateRangeClear = () => {
        this.setState({ fromDate: null, toDate: null, activePage: 1 }, () => {
            this.doRequest();
        });
    };

    changePage = (pageNumber) => {
        this.setState({ activePage: pageNumber.selected + 1 });
        setTimeout(() => {
            this.doRequest();
        }, 0);
    };

    changePageSize = (pageSize) => {
        this.setState({ pageSize: pageSize });
        setTimeout(() => {
            this.doRequest();
        }, 0);
    }

    getProviderList() {
        const { getProviders } = this.props;

        getProviders().then((res) => {
            if (res.payload && res.payload.status) {
                const providers = [];
                res.payload.data.forEach((item) => {
                    providers.push({label: item.name, value: item.name})
                })
                this.setState({ provider_list: providers });
            } else {
                this.setState({ provider_list: [] });
            }
        })
    }

    async handleChangeCheckbox(request) {
        const currentSelectedRows = { ...this.state.selectedRows };
        const isChecking = !currentSelectedRows[request.id].checked;

        currentSelectedRows[request.id] = {
            ...currentSelectedRows[request.id],
            checked: isChecking,
        };

        const checkedIds = Object.values(currentSelectedRows)
            .filter((row) => row.checked)
            .map((row) => row.id);

        this.setState({ selectedRows: currentSelectedRows, unionForIds: checkedIds, activePage: 1 }, () => {
            this.doRequest();
        });
    }

    createRefundRequestHandler = (isCreatingRefundRequestsuccessfully) => {
        if (isCreatingRefundRequestsuccessfully) {
            this.doRequest();
        }
    }

    createJoinRequestHandler = async () => {
        this.setState({ actionLoading: true });
        const checkedRows = Object.values(this.state.selectedRows).filter((row) => row.checked);
        try {
            const response = await this.props.postCreateJoinRequest(checkedRows.map((row) => row.id));
            if (response.type === 'POST_CREATE_JOIN_REQUEST_FAIL') {
                const errorData = response.error && response.error.response && response.error.response.data;
                const errorMessage = errorData && Array.isArray(errorData.error) ? errorData.error.join('; ') : 'Ошибка при объединении заявок';
                throw new Error(errorMessage);
            }
            this.setState({ unionForIds: [], activePage: 1 }, () => {
                this.doRequest();
            });
            this.setState({ snackBarAttr: {
                isVisible: true,
                message: 'Заявки успешно объединены',
                type: 'success',
            } });
        } catch (e) {
            this.setState({ snackBarAttr: {
                isVisible: true,
                message: e.message || 'Ошибка при объединении заявок',
            } });
        }
        this.setState({ actionLoading: false });
    }

    checkChildTagHandler = (event) => {
        if (event.target.closest('span')) {
            event.preventDefault();
        }
    }

    onSuccessSplit = () => {
        const clearedSelectedRows = Object.keys(this.state.selectedRows).reduce((acc, id) => {
            acc[id] = { ...this.state.selectedRows[id], checked: false };
            return acc;
        }, {});
        this.setState({ selectedRows: clearedSelectedRows, unionForIds: [], activePage: 1 }, () => {
            this.doRequest();
        });
    }

    render() {
        const { refund_requests: { all_refund_requests }} = this.props;
        const { loading, activePage, pageSize, valueSearch, status, projects_list, provider, provider_list, selectedRows, snackBarAttr, openRows, fromDate, toDate, ordering, ordering_options } = this.state;

        if (loading) return null;
        return (
            <TransitionedBlock>
                <div className="refund_requests_page container">
                    <div className="flex-center-btw title-block-page">
                        <div className="title-page">
                            <h1>Возвраты buyer</h1>
                        </div>
                        <RefundRequestsHeaderButtonsPanel
                            selectedRowsLength={this.selectedRowsLength}
                            selectedRows={selectedRows}
                            createJoinRequest={this.createJoinRequestHandler}
                            createRefundRequest={this.createRefundRequestHandler}
                            actionLoading={this.state.actionLoading}
                            refetch={this.doRequest}
                            onSuccess={this.onSuccessSplit}
                            availableTabs={['residue']}
                        />
                    </div>
                    <div className="page_block">
                        <PanelPage
                            doRequest={this.doRequest}
                            changeValueSearch={this.changeValueSearch}
                            handleSearch={this.handleSearch}
                            handleChange={this.handleChange}
                            valueSeacrh={valueSearch}
                            status={status}
                            projects_list={projects_list}
                            provider={provider}
                            provider_list={provider_list}
                            searchPlaceholder="Введите название компании, номер заказа/выдачи/УПД или артикул"
                            showDateRange
                            fromDate={fromDate}
                            toDate={toDate}
                            onDateRangeApply={this.handleDateRangeApply}
                            onDateRangeClear={this.handleDateRangeClear}
                            showOrderingSelect
                            ordering={ordering}
                            ordering_options={ordering_options}
                        />
                        <div className="refund_requests_table_wrapper">
                            <div className="transactions_table">
                                <div className="table_container transactions_columns">
                                    <div className="table_header">
                                        <div className="table_row">
                                            <div className="row_item"></div>
                                            <div className="row_item">Номер выдачи/УПД</div>
                                            <div className="row_item">Наименование</div>
                                            <div className="row_item">Артикул</div>
                                            <div className="row_item">Заказ</div>
                                            <div className="row_item">Компания</div>
                                            <div className="row_item">Поставщик</div>
                                            <div className="row_item">Дата/время</div>
                                            <div className="row_item">Статус</div>
                                            <div className="row_item">К-во товара</div>
                                            <div className="row_item">Сумма</div>
                                            <div className="row_item" />
                                        </div>
                                    </div>
                                    <div className="table_body">
                                        {all_refund_requests.results.length !== 0 ? all_refund_requests.results.map((request, idRequest) => {
                                            const isExpandable = Array.isArray(request.product_info) && request.product_info.length > 1;
                                            const isOpen = openRows[request.id];

                                            const mainProduct = Array.isArray(request.product_info) ? request.product_info[0] : request.product_info;
                                            const showExtra = isExpandable && !isOpen;

                                            return (
                                                <React.Fragment key={idRequest}>
                                                    <Link className="table_row"  to={`/admin/refund-request-buyer/${request.id}`} onClick={(e) => this.checkChildTagHandler(e)}>
                                                        <div className="row_item" style={{ cursor: isExpandable ? 'pointer' : 'default' }} onClick={(e) => {e.preventDefault();e.stopPropagation(); isExpandable && this.toggleRow(request.id)}}>
                                                            {isExpandable ? (
                                                                <span>{isOpen ? '▼' : '▶'}</span>
                                                            ) : null}
                                                        </div>
                                                        <div className="row_item">{request.upd_number || request.document_number}</div>
                                                       <div className="row_item">
                                                            {mainProduct.name || ''}
                                                        </div>
                                                        <div className="row_item">{mainProduct && mainProduct.article_number}</div>
                                                        <div className="row_item">{Array.isArray(request.ordernum) ? request.ordernum[0] : request.ordernum}{showExtra && Array.isArray(request.ordernum) && request.ordernum.length > 1 ? <span style={{ color: '#888', fontSize: 12, marginLeft: 4 }}>{`+${request.ordernum.length - 1}`}</span> : null}</div>
                                                        <div className="row_item">
                                                            {Array.isArray(request.company) ? (
                                                                request.product_info.length
                                                                    ? request.product_info[0].user
                                                                    : request.company.join(', ')
                                                            ) : request.company}
                                                            {showExtra && Array.isArray(request.company) && request.company.length > 1 && (
                                                                <span style={{ color: '#888', fontSize: 12, marginLeft: 4 }}>
                                                                    {`+${request.company.length - 1}`}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="row_item">{request.provider}</div>
                                                        <div className="row_item">{moment(request.date).format('DD.MM.YYYY HH:mm')}</div>
                                                        <div className="row_item">
                                                            {request.status ?
                                                                <div className="block_status_info">
                                                                    <span className="status" style={{background: `${getStatusColor(request.status)}`}} />
                                                                    <span className="text">{getStatusRefundRequest(request.status)}</span>
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                        <div className="row_item">{request.amount}</div>
                                                        <div className="row_item">
                                                            {formatPrice(request.price)}
                                                        </div>
                                                        { selectedRows[request.id] &&
                                                            (request.status !== 'denied' && request.status !== 'complete'  ? <Checkbox
                                                                className="row_item"
                                                                checked={selectedRows[request.id].checked}
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={() => this.handleChangeCheckbox(request)}
                                                            />: <div />)
                                                        }
                                                    </Link>
                                                    {/* Вложенные product_info */}
                                                    {isOpen && Array.isArray(request.product_info) && request.product_info.length > 1 && request.product_info.map((prod, idx) => (
                                                        <div className="table_row" key={idx} style={{ background: '#f9f9f9', fontSize: 13 }}>
                                                            <div className="row_item"></div>
                                                            <div className="row_item">{request.upd_number || request.document_number}</div>
                                                            <div className="row_item">{prod.name}</div>
                                                            <div className="row_item">{prod.article_number}</div>
                                                            <div className="row_item">{prod.ordernum || ''}</div>
                                                            <div className="row_item">{prod.user || ''}</div>
                                                            <div className="row_item">{request.provider}</div>
                                                            <div className="row_item"></div>
                                                            <div className="row_item"></div>
                                                            <div className="row_item">{prod.amount}</div>
                                                            <div className="row_item">{formatPrice(prod.price)}</div>
                                                            <div className="row_item"></div>
                                                        </div>
                                                    ))}
                                                </React.Fragment>
                                            );
                                        }) :
                                            <h1 style={{marginTop: '30px'}}>Заявок не найдено</h1>
                                        }
                                    </div>
                                </div>
                                <div className='control_panel'>
                                    {all_refund_requests.count && all_refund_requests.count > pageSize ?
                                        <div>
                                            <Pagination
                                                active={activePage}
                                                pageItemsCount={pageSize}
                                                pageTotalCount={all_refund_requests.count}
                                                onChange={this.changePage}
                                            />
                                        </div>
                                        : null}
                                    <ControlPanel onChange={(event) => this.changePageSize(event.target.value)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SnackBar
                    open={snackBarAttr.isVisible}
                    classes={snackBarAttr.type === 'success' ? 'success' : 'error'}
                    vertical="top"
                    onClose={() => this.toggleSnack()}
                >
                    {snackBarAttr.message}
                </SnackBar>
            </TransitionedBlock>
        );
    }
}

const mapStateToProps = ({refund_requests}) => ({
    refund_requests
});

const mapDispatchToProps = {
    getRefundRequests,
    getProviders,
    postCreateJoinRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RefundRequestsBuyer);
